import React from 'react'
// import { useNavigate } from 'react-router-dom'

const WelcomeView: React.FC = () => {
  // const navigate = useNavigate()

  const navigateToAuth = () => {
    // navigate('/home')
    window.location.replace('/home')
  }

  return (
    <>
      <header className="w-full flex flex-row bg-primary items-center justify-between max-w-screen-md mx-auto py-5 px-5">
        <div className="flex mx-auto">
          <img src="/img/appLogo.svg" alt="appLogo" loading="lazy" className="appLogo" />
        </div>
      </header>

      <div className="p-5 wrapper max-w-screen-md mx-0 sm:mx-auto md:mx-auto lg:mx-auto flex flex-col mt-auto h-[80%] text-white">
        <p className="text-center text-4xl font-bold sm:text-5xl sm:tracking-tight lg:text-6xl">
          Добрый день!
        </p>
        <p className="text-center text-xl my-10 font-semibold">
          Рады приветствовать Вас на Единой цифровой платформе "Сбор членских взносов".
        </p>
        <p className="text-center text-base">
          Данная платформа поможет Вам оперативно совершать онлайн-оплату членских взносов,
          контролировать задолженности по уплате и отслеживать историю осуществленных платежей.
        </p>
        <button
          type="submit"
          className="text-black bg-[#F3F3F3] w-full text-base rounded-xl py-5 px-4 focus:outline-none focus:ring-white focus:border-white font-semibold mt-10"
          onClick={navigateToAuth}
        >
          Продолжить
        </button>
      </div>
    </>
  )
}

export default WelcomeView
